import { FeatureHeader } from "@/shared/components/custom/FeatureHeader";
import { Button } from "@/shared/components/ui/button";
import { ListVideo, Plus, RefreshCw } from "lucide-react";


const StoryboardHeader = ({
    sceneTitle,
    displayedFramesCount,
    isFiltered,
    selectedShot,
    hasSelectedShotFrames,
    hasFrames,
    currentSceneShots,
    showShotList,
    onInitiateFrameGeneration,
    onCreateManualFrame,
    onClearSelection,
    onRegenerateAll,
    onToggleShotList,
    onAddFrame
}: {
    sceneTitle: string;
    displayedFramesCount: number;
    isFiltered: boolean;
    selectedShot: any;
    hasSelectedShotFrames: boolean;
    hasFrames: boolean;
    currentSceneShots: any[];
    showShotList: boolean;
    onInitiateFrameGeneration: (shot: any) => void;
    onCreateManualFrame: () => void;
    onClearSelection: () => void;
    onRegenerateAll: () => void;
    onToggleShotList: () => void;
    onAddFrame: () => void;
}) => {
    return (
        <FeatureHeader
            className="p-6 pb-0"
            title={sceneTitle}
            subtitle={
                <>
                    {displayedFramesCount} frame{displayedFramesCount !== 1 ? 's' : ''}
                    {isFiltered ? ' (filtered)' : ''}
                </>
            }
            actions={
                <>
                    {!selectedShot && hasFrames && (
                        <Button variant="ghost" size="sm" onClick={onClearSelection}>
                            View All Frames
                        </Button>
                    )}

                    {selectedShot && (
                        <>
                            <Button size="sm" variant="outline" onClick={onCreateManualFrame}>
                                <Plus className="h-4 w-4 mr-2" />
                                Add Frame
                            </Button>
                            {hasSelectedShotFrames && (
                                <Button size="sm" onClick={() => onInitiateFrameGeneration(selectedShot)}>
                                    <RefreshCw className="h-4 w-4 mr-2" />
                                    Regenerate
                                </Button>
                            )}
                            {hasFrames && (
                                <Button variant="ghost" size="sm" onClick={onClearSelection}>
                                    View All Frames
                                </Button>
                            )}
                        </>
                    )}

                    {hasFrames && !showShotList && (
                        <Button
                            variant="outline"
                            size="sm"
                            onClick={onToggleShotList}
                            className="gap-2"
                        >
                            <ListVideo className="h-4 w-4" />
                            Show Shot List
                        </Button>
                    )}

                </>
            }
        />
    )
}
export default StoryboardHeader
